import {PointOfInterest} from 'data/records'
import {resource, findSelector} from 'data/helpers/apiv3'

const [api, actions] = resource(PointOfInterest, [])

const selectors = {
  ...findSelector(PointOfInterest)
}

const reducers = {}

const initialState = {}

export {
  api as pointOfInterestApi,
  actions as pointOfInterestActions,
  selectors as pointOfInterestSelectors,
  reducers as pointOfInterestReducers,
  initialState as pointOfInterestInitialState
}
